var _excluded = ["type", "id", "size", "className", "hasError", "iconLeft", "iconRight", "customIconLeft", "customIconRight", "icon", "customIcon", "inputRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { string, oneOf, bool, oneOfType, element, func, shape, instanceOf } from 'prop-types';
import classNames from 'classnames';
import './Input.scss';
import Icon from '../../Icon/Icon';
var propTypes = {
  /** The ID */
  id: string,

  /** The size */
  size: oneOf(['small', 'medium', 'large']),

  /** Choose between these different types of inputs */
  type: oneOf(['text', 'search', 'email', 'url', 'tel', 'number', 'date', 'month', 'week', 'time', 'datetime', 'datetime-local', 'color', 'file', 'password']),

  /** Left aligned icon. 
   * 
   * `type` must be one of `text`, `search`, `email`, `url`, `tel` or `password` for icon to be valid. */
  iconLeft: element,

  /** Right aligned icon. */
  iconRight: element,

  /** Left aligned custom icon. 
   *  
   * `type` must be one of `text`, `search`, `email`, `url`, `tel` or `password` for customIcon to be valid. */
  customIconLeft: string,

  /** Right aligned custom icon. */
  customIconRight: string,

  /** Visual presentation of an hasError in the input */
  hasError: bool,

  /** Add your own custom class names to the component */
  className: string,

  /** Reference that can be used for setting focus to the component */
  inputRef: oneOfType([func, shape({
    current: instanceOf(element)
  })])
};
var defaultProps = {
  type: 'text',
  size: 'medium',
  hasError: false
};
/** The input component is used for data entry. */

var Input = function Input(_ref) {
  var type = _ref.type,
      id = _ref.id,
      size = _ref.size,
      className = _ref.className,
      hasError = _ref.hasError,
      iconLeft = _ref.iconLeft,
      iconRight = _ref.iconRight,
      customIconLeft = _ref.customIconLeft,
      customIconRight = _ref.customIconRight,
      icon = _ref.icon,
      customIcon = _ref.customIcon,
      inputRef = _ref.inputRef,
      rest = _objectWithoutProperties(_ref, _excluded);

  var inputClassNames = classNames('rds-field rds-input', {
    'rds-input--danger': hasError,
    'rds-input--small': size === 'small',
    'rds-input--medium': size === 'medium' || size === '' || size === null,
    'rds-input--large': size === 'large',
    'rds-input--has-icon rds-input--has-icon-right': iconRight || customIconRight,
    'rds-input--has-icon rds-input--has-icon-left': iconLeft || customIconLeft
  }, className);
  var wrapperClassNames = classNames('rds-field-wrapper', {
    'rds-field-wrapper--small': size === 'small',
    'rds-field-wrapper--medium': size === 'medium' || !size,
    'rds-field-wrapper--large': size === 'large'
  });
  if (type === 'range') return /*#__PURE__*/React.createElement("div", {
    className: 'rds-danger'
  }, " Please use Slider component! ");

  if ((type === 'text' || type === 'search' || type === 'email' || type === 'url' || type === 'tel' || type === 'password') && (iconRight || customIconRight)) {
    return /*#__PURE__*/React.createElement("div", {
      className: wrapperClassNames
    }, /*#__PURE__*/React.createElement("input", _extends({
      className: inputClassNames,
      type: type,
      id: id,
      "aria-invalid": hasError,
      ref: inputRef
    }, rest)), /*#__PURE__*/React.createElement(Icon, {
      customIconPath: customIconRight,
      component: iconRight,
      size: size
    }));
  } else if ((type === 'text' || type === 'search' || type === 'email' || type === 'url' || type === 'tel' || type === 'password') && (iconLeft || customIconLeft)) {
    return /*#__PURE__*/React.createElement("div", {
      className: wrapperClassNames
    }, /*#__PURE__*/React.createElement("input", _extends({
      className: inputClassNames,
      type: type,
      id: id,
      "aria-invalid": hasError,
      ref: inputRef
    }, rest)), /*#__PURE__*/React.createElement(Icon, {
      customIconPath: customIconLeft,
      component: iconLeft,
      size: size
    }));
  } else {
    return /*#__PURE__*/React.createElement("input", _extends({
      className: inputClassNames,
      type: type,
      id: id,
      "aria-invalid": hasError,
      ref: inputRef
    }, rest));
  }
};

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;
export default Input;